import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {SellableSearchModel} from "../sellable-search.model";
import {SellableSearchPageComponent} from "../sellable-search-page/sellable-search-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {FUISelectAction} from "@fedeltapointofsale/ui";
import {ProductLineEditPageComponent} from "../../product-line/product-line-edit-page/product-line-edit-page.component";
import {
    CompositeProductEditPageComponent
} from "../../composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {SellableData} from "../sellable.data";

@Component({
    selector: "wbo-sellable-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(SellableSingleSelectEditControlComponent),
        provideSearchModel(SellableSearchModel)
    ]
})
export class SellableSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SellableSearchModel> {
    constructor(model: SellableSearchModel, injector: Injector) {
        super(model, injector, "sellableId", "name");

        this.extendedSearchComponent = SellableSearchPageComponent;
        this.showOptionOpenOption = true;

        this.actions = [
            {
                name: "product-line",
                title: "wbo.sellable.option.addProductLine",
                icon: "add-burger",
                iconHeight: 26,
                iconWidth: 26
            }, {
                name: "composite-product",
                title: "wbo.sellable.option.addCompositeProduct",
                icon: "add-burger-combo",
                iconHeight: 26,
                iconWidth: 26
            }
        ];
    }


    override onOptionOpen(option: any) {
        if (option.sellableType === SellableData.SELLABLE_TYPE_PRODUCT_LINE) {
            this.selectControlComponent.openView(option, false, ProductLineEditPageComponent);
        } else if (option.sellableType === SellableData.SELLABLE_TYPE_COMPOSITE_PRODUCT) {
            this.selectControlComponent.openView(option, false, CompositeProductEditPageComponent);
        }
    }

    override onAction(action: FUISelectAction) {
        if (action.name === "product-line") {
            this.selectControlComponent.openAdd(ProductLineEditPageComponent);
        } else if (action.name === "composite-product") {
            this.selectControlComponent.openAdd(CompositeProductEditPageComponent);
        }
    }
}
